import { c as _c } from "react/compiler-runtime";
import { IconBook } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { IconArrowRotateAnticlockwiseOutline18 } from "nucleo-ui-outline-18";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import FormField from "@/app/(v2)/workflows/_components/form-fields/FormField";
import { JsonSchemaProperty } from "./types";
interface IntegrationInputFieldsProps {
  allFields: string[];
  requiredFields: string[];
  filteredFields: [string, JsonSchemaProperty][];
  previewValues: Record<string, unknown>;
  setPreviewValues: (fn: (prev: Record<string, unknown>) => Record<string, unknown>) => void;
  formKey: number;
  setFormKey: (fn: (prev: number) => number) => void;
}
export function IntegrationInputFields(t0) {
  const $ = _c(22);
  const {
    allFields,
    requiredFields,
    filteredFields,
    previewValues,
    setPreviewValues,
    formKey,
    setFormKey
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconBook className="h-5 w-5 text-blue-600 dark:text-blue-400" />;
    t2 = <h2 className="text-ds-text-primary text-lg font-semibold">Input</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = allFields.length !== 1 ? "s" : "";
  let t4;
  if ($[2] !== allFields.length || $[3] !== t3) {
    t4 = <div className="flex items-center gap-2">{t1}{t2}<Badge className="ml-1">{allFields.length} field{t3}</Badge></div>;
    $[2] = allFields.length;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== previewValues || $[6] !== setFormKey || $[7] !== setPreviewValues) {
    t5 = Object.keys(previewValues).length > 0 && <Button variant="ghost" size="sm" className="text-ds-text-muted hover:text-ds-text-secondary h-8 text-xs dark:hover:text-zinc-200" onClick={() => {
      setPreviewValues(_temp);
      setFormKey(_temp2);
    }}><IconArrowRotateAnticlockwiseOutline18 className="mr-1.5 h-3 w-3" />Clear all</Button>;
    $[5] = previewValues;
    $[6] = setFormKey;
    $[7] = setPreviewValues;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="border-ds-border-default flex items-center justify-between border-b pb-4">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== allFields.length || $[13] !== filteredFields || $[14] !== formKey || $[15] !== previewValues || $[16] !== requiredFields || $[17] !== setPreviewValues) {
    t7 = <div>{allFields.length > 0 ? filteredFields.length > 0 ? <Accordion type="multiple" defaultValue={[]}>{filteredFields.map(t8 => {
          const [fieldName, fieldSchema] = t8;
          const isRequired = requiredFields.includes(fieldName);
          return <AccordionItem key={fieldName} value={fieldName} className="border-ds-border-default border-b last:border-b-0"><AccordionTrigger className="dark:hover:bg-ds-neutral-800/50 hover:bg-ds-surface-hover px-1 py-3 hover:no-underline"><div className="flex w-full items-center gap-3 pr-2"><code className="bg-ds-neutral-100 text-ds-text-secondary dark:bg-ds-neutral-800 rounded-md px-2 py-1 font-mono text-sm">{fieldName}</code>{isRequired && <span className="text-xs font-medium text-red-500">*</span>}<span className="label-xs">{fieldSchema.type || "string"}</span></div></AccordionTrigger><AccordionContent className="px-1 pb-3 pt-1"><div className="dark:bg-ds-neutral-800/30 space-y-3 rounded-lg bg-zinc-50 p-4">{fieldSchema.description && <p className="body-sm">{fieldSchema.description}</p>}{fieldSchema.enum && <div><div className="text-ds-text-muted mb-1.5 text-xs font-medium">Allowed values</div><div className="flex flex-wrap gap-1.5">{fieldSchema.enum.map(_temp3)}</div></div>}{fieldSchema.default !== undefined && <div className="label-xs">Default:{" "}<code className="shadow-ds-soft bg-ds-surface-card ml-1 rounded-md px-1.5 py-0.5 font-mono">{String(fieldSchema.default)}</code></div>}<div className="pt-2"><FormField key={`${fieldName}-${formKey}`} name={fieldName} property={{
                    ...fieldSchema,
                    required: isRequired
                  }} value={previewValues[fieldName]} onChange={(name, value_0) => {
                    setPreviewValues(prev_0 => ({
                      ...prev_0,
                      [name]: value_0
                    }));
                  }} allValues={previewValues} currentNodeId="preview" allNodes={[]} allEdges={[]} currentNodePayload={previewValues} hideLabel={true} /></div></div></AccordionContent></AccordionItem>;
        })}</Accordion> : <div className="px-1 py-8 text-center"><p className="text-ds-text-muted text-sm">No fields match your search.</p></div> : <div className="px-1 py-8 text-center"><p className="text-ds-text-muted text-sm">No input fields required.</p></div>}</div>;
    $[12] = allFields.length;
    $[13] = filteredFields;
    $[14] = formKey;
    $[15] = previewValues;
    $[16] = requiredFields;
    $[17] = setPreviewValues;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp3(value) {
  return <code key={String(value)} className="text-ds-text-subtle shadow-ds-soft bg-ds-surface-card rounded-md px-2 py-1 font-mono text-xs">{value}</code>;
}
function _temp2(prev) {
  return prev + 1;
}
function _temp() {
  return {};
}